import { PosterUpdatePage } from "@/features/poster/pages/PosterUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/poster/$id/update")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["poster.edit"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: PosterUpdatePage,
});
